import { Money } from './money';

export class Umsatz {
  constructor({
    produktivitaet,
    wert,
    stunden,
  }: {
    produktivitaet?: Money;
    wert?: Money;
    stunden?: number;
  }) {
    this.produktivitaet = produktivitaet;
    this.stunden = stunden;
    this.wert = wert;
  }

  readonly produktivitaet?: Money;
  readonly wert?: Money;
  readonly stunden?: number;
}

export class UmsatzPlan {
  constructor({
    prognose,
    umsatz,
  }: {
    readonly umsatz: Umsatz;
    readonly prognose: Money | null;
  }) {
    this.prognose = prognose;
    this.umsatz = umsatz;
  }

  readonly umsatz: Umsatz;
  readonly prognose: Money | null;
}
